import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
import { VarietyName, VarietiesProps } from 'services/varieties/types';
import { makeSelectVarietyName } from 'services/varieties/selectors';

type OwnProps = VarietiesProps;

interface ConnectedProps {
    name?: VarietyName;
}

type Props = OwnProps & ConnectedProps;

export class VarietyNameValueComponent extends React.PureComponent<Props> {
    render(): VarietyName | null {
        const { name } = this.props;

        if (!name) {
            return null;
        }

        return name;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    name: makeSelectVarietyName()
});

export default connect(mapStateToProps)(VarietyNameValueComponent);
